import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { ApiTokenDTO, CreateTokenDTO, CreatedTokenDTO } from "../../shared/schemas";
import { apiFetch } from "./client";

const TOKENS_KEY = ["tokens"] as const;

export function useTokensQuery() {
  return useQuery<ApiTokenDTO[]>({
    queryKey: TOKENS_KEY,
    queryFn: () => apiFetch<ApiTokenDTO[]>("/tokens"),
  });
}

export function useCreateToken() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateTokenDTO) =>
      apiFetch<CreatedTokenDTO>("/tokens", {
        method: "POST",
        body: JSON.stringify(data),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TOKENS_KEY }),
  });
}

export function useDeleteToken() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      apiFetch<void>(`/tokens/${id}`, { method: "DELETE" }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TOKENS_KEY }),
  });
}
